import { createSlice } from '@reduxjs/toolkit';
import axios from 'services/ApiAdaptor';

const initialState = {
  lists: [],
  error: null
};

const slice = createSlice({
  name: 'factoryMachinePlcAddressFilters',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
    },
    createFactoryMachinePlcAddressFilters(state, action) {
      state.lists.push(action.payload);
    }
  }
});

export const { createFactoryMachinePlcAddressFilters } = slice.actions;
export default slice.reducer;

const getMultipartConfig = () => {
  const token = window.localStorage.getItem('serviceToken');
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  if (token) {
    config.headers['x-access-token'] = token;
  }
  return config;
};

export function getFactoryMachinePlcAddressFiltersUpsert(newFilters) {
  return async (dispatch) => {
    try {
      const formData = new FormData();
      formData.append('filters', JSON.stringify(newFilters.filters));

      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/factoryMachinePlcAddressFilters/Upsert`, formData, getMultipartConfig());

      if (response.status === 200) {
        dispatch(createFactoryMachinePlcAddressFilters(response.data));
        return { success: true, data: response.data };
      } else {
        throw new Error(response.data.message || 'Failed to upsert filters');
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.message || 'An error occurred'));
      return { success: false, error: error.message };
    }
  };
}
